import Page from "./app/feature/chatBotPage/Page";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { useEffect } from "react";
import { Provider } from "react-redux";
import { setError, setUser } from "./errorHandler";
import NewTablePdfCost from "./app/shared/components/NewTablePdfCost";

/* set params for error info */

const App = ({ store }: any) => {
  // catch all errors of the application and ....
  try {
    window.onerror = (msg, url, lineNo, columnNo, error) => {
      // ... send they to errorHandler for logging
      setError(`*** CUSTOM ERROR **** ${msg} ${url}`);
      return true;
    };
  } catch (e) {
    console.log("Some Errors: ", e);
  }

  useEffect(() => {
    // get uid from session storage
    const uid = window.sessionStorage.getItem("uid") ?? "no-uid";
    const idToken = window.sessionStorage.getItem("idToken") ?? "no-Token";
    //
    // send uid to track user
    setUser({ uid });
  });

  return (
    <div >
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Page />} />
          <Route path="/table" element={<NewTablePdfCost />} />
        </Routes>
      </BrowserRouter>
    </Provider>
    </div>
  );
};

export default App;
